import ProductList from './productList'

export default ProductList
